import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import {
  CardContent,
  Grid,
  Card as MuiCard,
  LinearProgress,
  Typography,
  Button,
} from "@mui/material";
import PostAddIcon from "@mui/icons-material/PostAdd";

import * as Enums from "src/utils/enums";
import useForm from "src/hooks/useForm";

import { getNextCode } from "src/services/AWB/awbService";
import { DefaultService } from "src/services/defaultService";
import { toast } from "react-toastify";

import { parseAndRound } from "src/utils/amUtils";
import { getCaption } from "src/utils/dictionary";
import _ from "lodash";

import AMIndexList from "src/pages/components/AMIndexList";
// import AWBTrxFooter from "./AWBTrxFooter";
import { padding } from "polished";
import { useTheme } from "@mui/material/styles";
import { useDialog } from "dialog-hook";

const Card = styled(MuiCard)(spacing);

function AWBTrxPage({ menuItemCode }) {
  const theme = useTheme();
  const dialog = useDialog({ ok: "ok", cancel: null });
  const defaultService = new DefaultService("AwbSales");
  const [isGeneratingInvoice, setIsGeneratingInvoice] = useState(false);

  //#region Api Calls
  const getNextCodeFunc = async () => {
    if (values && values.trxDate) {
      const { data } = await getNextCode(menuItemCode, values.trxDate);
      return data || "";
    } else return "";
  };

  const getByIdFunc = async (id) => {
    const { data } = await defaultService.get(menuItemCode, id);
 //Remove id if rendered from server to keep id as it comes from url and not enter in infinite loop
    //also if not remoced copy form will not work
    if (data) {
      delete data.id;
      delete data.ID;
      delete data.Id;
      delete data.iD;
    }
    return data;
  };

  const saveFormFunction = async (menuItemCode, formData) => {
    if (formData.trxFooter && formData.trxFooter) {
      const totalCredit = parseAndRound(
        _.sumBy(formData.trxFooter, function (o) {
          return parseAndRound(o.displayCredit);
        }),
        //It sums as string _.sumBy(tableData, "displayCredit"),
        4
      );
      const totalDebit = parseAndRound(
        _.sumBy(formData.trxFooter, function (o) {
          return parseAndRound(o.displayDebit);
        }),
        4
      );

      if (totalCredit !== totalDebit) {
        toast.error(getCaption("total_credit_must_equal_total_debit"));
        return false;
      }
    }

    const { data } = await defaultService.save(menuItemCode, formData);
    return data;
  };

  const deleteFunction = async (menuItemCode, formData) => {
    const { data } = await defaultService.delete(menuItemCode, formData);
    return data;
  };

  //#endRegion

  const {
    state: values,
    handleSetState,
    indexColumns,
    renderFormHeader,
    renderFormInput,
    preLoaded,
    formControls,
    vaLidateFormData,
  } = useForm({
    menuItemCode: menuItemCode,
    nextCodeField: "code",
    getNextCodeFunc: getNextCodeFunc,
    getByIdFunc: getByIdFunc,
    saveFunction: saveFormFunction,
    deleteFunction: deleteFunction,
  });

  const handelGenerateInvoice = async (saveType) => {
    try {
      if (!vaLidateFormData()) return false;
      setIsGeneratingInvoice(true);

      const payLoadData = JSON.parse(JSON.stringify(values));
      // if (
      //   payLoadData.id.toLowerCase() === "add".toLowerCase() ||
      //   !payLoadData.id
      // ) {
      //   throw new Error("Save Form first.");
      //   setIsGeneratingInvoice(false);
      //   return;
      // }

      payLoadData.saveAndGenerateInvoice = true;
      const data = await saveFormFunction(menuItemCode, payLoadData);
      if (!data) {
        setIsGeneratingInvoice(false);
        return false;
      }
      const newState = { ...data };
      handleSetState(newState);
      setIsGeneratingInvoice(false);
      toast.success(getCaption("save_done"));
      return true;
    } catch (err) {
      setIsGeneratingInvoice(false);
      toast.error(
        err.response && err.response.data ? err.response.data : err.message
      );
      return false;
    }
  };
  useEffect(() => {
    if (!preLoaded || !values.trxDate) return;
    if (!values.id || values.id.toLowerCase() !== "add".toLowerCase()) return;
    /*set NextCode*/
    (async () => {
      try {
        const nextCode = await getNextCodeFunc();
        const newState = { ...values };
        newState["serialNo"] = nextCode;
        handleSetState(newState);
      } catch (error) {
        console.log(error.message);
      }
    })();
  }, [preLoaded, values.trxDate]);

  // useEffect(() => {
  //   if (!preLoaded || !values.awbNo) return;
  //   /*set NextCode*/
  //   (async () => {
  //     try {
  //       const nextCode = await getAwbData();
  //       const newState = { ...values };
  //       newState["serialNo"] = nextCode;
  //       handleSetState(newState);
  //     } catch (error) {
  //       console.log(error.message);
  //     }
  //   })();
  // }, [preLoaded, values.awbNo]);

  //#region Save Details
  const handleSetTrxFooter = (newTrxFooter) => {
    const newState = { ...values };
    newState.trxFooter = [...newTrxFooter];
    handleSetState(newState);
  };
  //#endregion

  if (!preLoaded) return <LinearProgress my={2} />;

  const custAndShipperData = (
    <Card mb={3} style={{ paddingBottom: 5, paddingTop: 5 }}>
      <CardContent style={{ paddingBottom: 5, paddingTop: 5 }}>
        <Typography variant="h6" color="primary">
          Customer And Shipper Data
        </Typography>
        <Grid container spacing={1}>
          {/* {renderFormInput(
            "operationType",
            Enums.ControlType.AutoComplete,
            null,
            null,
            operationTypes
          )} */}
          {renderFormInput("customerID", Enums.ControlType.AutoSearch, null, {
            xs: 12,
          })}
          {renderFormInput("shipperName", Enums.ControlType.TextField, null, {
            xs: 12,
          })}
          {renderFormInput("shipperPhone1", Enums.ControlType.TextField, null, {
            xs: 4,
          })}
          {renderFormInput("shipperPhone2", Enums.ControlType.TextField, null, {
            xs: 4,
          })}
          {renderFormInput("shipperPhone3", Enums.ControlType.TextField, null, {
            xs: 4,
          })}
          {renderFormInput(
            "shipperAddress1",
            Enums.ControlType.TextField,
            { multiline: true, rows: 2 },
            {
              xs: 12,
            }
          )}
          {renderFormInput(
            "shipperAddress2",
            Enums.ControlType.TextField,
            null,
            {
              xs: 12,
            }
          )}

          {/* {renderFormInput("notes", Enums.ControlType.TextField, null, {
            xs: 12,
            style: { paddingBottom: 5, paddingTop: 5 },
          })} */}
        </Grid>
      </CardContent>
    </Card>
  );

  const ConsigneeData = (
    <Card mb={3}>
      <CardContent style={{ paddingBottom: 5, paddingTop: 5 }}>
        <Typography variant="h6" color="primary">
          Consignee Data
        </Typography>
        <Grid container spacing={1}>
          {renderFormInput("consigneeName", Enums.ControlType.TextField, null, {
            xs: 12,
          })}
          {renderFormInput(
            "consigneePhone1",
            Enums.ControlType.TextField,
            null,
            {
              xs: 4,
            }
          )}
          {renderFormInput(
            "consigneePhone2",
            Enums.ControlType.TextField,
            null,
            {
              xs: 4,
            }
          )}
          {renderFormInput(
            "consigneePhone3",
            Enums.ControlType.TextField,
            null,
            {
              xs: 4,
            }
          )}
          {renderFormInput(
            "consigneeAddress1",
            Enums.ControlType.TextField,
            { multiline: true, rows: 2 },
            {
              xs: 12,
            }
          )}
          {renderFormInput(
            "consigneeAddress2",
            Enums.ControlType.TextField,
            { multiline: true, rows: 2 },
            {
              xs: 12,
            }
          )}
        </Grid>
      </CardContent>
    </Card>
  );

  const AWBBillingData = (
    <Card mb={3}>
      <CardContent
        style={{
          paddingBottom: 5,
          paddingTop: 5,
          backgroundColor:
            theme.name === "DARK" ? "rgba(192,192,192, 0.2)" : "#fff9c4",
        }}
      >
        <Typography variant="h6" color="primary">
          AWB Billing
        </Typography>
        <Grid container spacing={1}>
          {renderFormInput(
            "chargeableWeight",
            Enums.ControlType.TextField,
            { disabled: true },
            {
              xs: 12,
            }
          )}
          {renderFormInput(
            "xRayAmt",
            Enums.ControlType.TextField,
            { disabled: true },
            {
              xs: 6,
            }
          )}
          {renderFormInput(
            "customsAmt",
            Enums.ControlType.TextField,
            { disabled: true },
            {
              xs: 6,
            }
          )}
          {renderFormInput("insuranceAmt", Enums.ControlType.TextField, null, {
            xs: 6,
          })}
          {renderFormInput("packingAmt", Enums.ControlType.TextField, null, {
            xs: 6,
          })}
          {renderFormInput(
            "transportationAmt",
            Enums.ControlType.TextField,
            null,
            { xs: 12 }
          )}
          {renderFormInput("handlingAmt", Enums.ControlType.TextField, null, {
            xs: 12,
          })}
          {renderFormInput("ddChargeAmt", Enums.ControlType.TextField, null, {
            xs: 12,
          })}
          {renderFormInput("othersAmt", Enums.ControlType.TextField, null, {
            xs: 12,
          })}
          {renderFormInput("frightAmt", Enums.ControlType.TextField, null, {
            xs: 12,
          })}
          {renderFormInput(
            "billingTotal",
            Enums.ControlType.TextField,
            { disabled: true },
            {
              xs: 12,
            }
          )}
          {renderFormInput("cash", Enums.ControlType.CheckBox)}
          <Grid item xs={12}>
            {!!values.invoiceNumber && (
              <Typography variant="h6" color="primary">
                Invoice Number.:({values.invoiceNumber})
              </Typography>
            )}
            {!values.invoiceNumber && (
              <Button
                mr={2}
                variant="contained"
                fullWidth
                onClick={() => {
                  dialog({
                    title: "Warning!",
                    message:
                      "Once you click Ok Invoice will be generated and you will not be able to modify AWB data. Are you sure you want to generate invoice?",
                  }).then(handelGenerateInvoice);
                }}
                // disabled={isSubmitting}
                color="warning"
              >
                Generate Invoice
                <PostAddIcon />
              </Button>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  const awbData = (
    <Card mb={3} style={{ paddingBottom: 5, paddingTop: 5 }}>
      <CardContent style={{ paddingBottom: 5, paddingTop: 5 }}>
        <Typography variant="h6" color="primary">
          Main Data
          {/* AWB And Supplier Data */}
        </Typography>
        <Grid container spacing={1}>
          {renderFormInput("trxDate", Enums.ControlType.DatePicker, null, {
            xs: 6,
          })}
          {renderFormInput("serialNo", Enums.ControlType.TextField, {
            disabled: true,
            style: { maxWidth: 100 },
          })}
          {renderFormInput("awbNo", Enums.ControlType.AutoSearch, null, {
            xs: 6,
          })}
          {renderFormInput("salesAgentID", Enums.ControlType.AutoSearch, null, {
            xs: 6,
          })}
          {renderFormInput("supplierID", Enums.ControlType.AutoSearch, null, {
            xs: 12,
          })}
          {renderFormInput(
            "clearingAgentID",
            Enums.ControlType.AutoSearch,
            null,
            {
              xs: 12,
            }
          )}
          {renderFormInput("airPortOfDep", Enums.ControlType.TextField, null, {
            xs: 6,
          })}
          {renderFormInput("airPortOfDest", Enums.ControlType.TextField, null, {
            xs: 6,
          })}
          {renderFormInput("toDest1ID", Enums.ControlType.AutoSearch, null, {
            xs: 3,
          })}
          {renderFormInput("byCarrier1ID", Enums.ControlType.AutoSearch, null, {
            xs: 3,
          })}
          {renderFormInput("flightInfo1", Enums.ControlType.TextField, null, {
            xs: 6,
          })}
          {renderFormInput("toDest2ID", Enums.ControlType.AutoSearch, null, {
            xs: 3,
          })}
          {renderFormInput("byCarrier2ID", Enums.ControlType.AutoSearch, null, {
            xs: 3,
          })}
          {renderFormInput("flightInfo2", Enums.ControlType.TextField, null, {
            xs: 6,
          })}
          {renderFormInput("toDest3ID", Enums.ControlType.AutoSearch, null, {
            xs: 3,
          })}
          {renderFormInput("byCarrier3ID", Enums.ControlType.AutoSearch, null, {
            xs: 3,
          })}
          {renderFormInput("flightInfo3", Enums.ControlType.TextField, null, {
            xs: 6,
          })}
          {renderFormInput(
            "handlingInfo",
            Enums.ControlType.TextField,
            { multiline: true, rows: 3 },
            {
              xs: 12,
            }
          )}
          {renderFormInput("qtnNo", Enums.ControlType.TextField, null, {
            xs: 4,
          })}
          {renderFormInput("referenceNo", Enums.ControlType.TextField, null, {
            xs: 4,
          })}
          {renderFormInput(
            "postNo",
            Enums.ControlType.TextField,
            {
              disabled: true,
            },
            {
              xs: 4,
            }
          )}
          {/* {renderFormInput("notes", Enums.ControlType.TextField, null, {
            xs: 12,
            style: { paddingBottom: 5, paddingTop: 5 },
          })} */}
        </Grid>
      </CardContent>
    </Card>
  );

  const fProp = { xs: 4, md: 1 };
  const finData = (
    <Card mb={3} style={{ paddingBottom: 5, paddingTop: 5 }}>
      <CardContent style={{ paddingBottom: 5, paddingTop: 5 }}>
        <Typography variant="h6" color="primary">
          Main Data
          {/* AWB And Supplier Data */}
        </Typography>
        <Grid container spacing={1}>
          {renderFormInput(
            "specialRate",
            Enums.ControlType.CheckBox,
            null,
            fProp
          )}
          {renderFormInput("qty", Enums.ControlType.TextField, null, fProp)}
          {renderFormInput(
            "grossWeight",
            Enums.ControlType.TextField,
            null,
            fProp
          )}
          {renderFormInput(
            "unit",
            Enums.ControlType.AutoComplete,
            null,
            fProp,
            [
              { valueField: "K", textField: "K" },
              { valueField: "L", textField: "L" },
            ]
          )}
          {renderFormInput(
            "iATARateClassID",
            Enums.ControlType.AutoSearch,
            null,
            fProp
          )}
          {renderFormInput("itemNo", Enums.ControlType.TextField, null, fProp)}
          {renderFormInput(
            "cargoTypeID",
            Enums.ControlType.AutoSearch,
            null,
            fProp
          )}
          {renderFormInput(
            "chargeableWeight",
            Enums.ControlType.TextField,
            null,
            fProp
          )}
          {renderFormInput(
            "iATARate",
            Enums.ControlType.TextField,
            null,
            fProp
          )}
          {renderFormInput(
            "aLRateClassID",
            Enums.ControlType.AutoSearch,
            null,
            fProp
          )}
          {renderFormInput(
            "airlineRate",
            Enums.ControlType.TextField,
            null,
            fProp
          )}
          {renderFormInput("amount", Enums.ControlType.TextField, null, fProp)}
          {renderFormInput(
            "goodsDescription",
            Enums.ControlType.TextField,
            null,
            { xs: 12 }
          )}
        </Grid>
      </CardContent>
    </Card>
  );
  const colProps = { xs: 12, md: 5, lg: 5, xl: 5 };

  return (
    <React.Fragment>
      {renderFormHeader()}
      {!values.id && indexColumns && !!indexColumns.length && (
        <AMIndexList
          key={indexColumns.length}
          columns={indexColumns}
          // title={title}
          // filterControls={filterControls}
          // criteria={criteria}
          // onApplyFilter={onApplyFilter}
          getAll={defaultService.getAll}
        />
      )}
      {!!values.id && (
        <Grid container spacing={2}>
          <Grid item {...colProps}>
            {awbData}
          </Grid>{" "}
          <Grid item {...colProps}>
            {custAndShipperData}
            {ConsigneeData}
          </Grid>
          <Grid item xs={12} md={2}>
            {AWBBillingData}
          </Grid>
          <Grid item xs={12}>
            {finData}
            {/* <AWBTrxFooter
              formControls={formControls}
              title="Test Footer"
              // saveRow={handleSaveRow}    I've moved this functions to the chiled component
              // deleteRow={handleDeleteRow}
              tableData={values.trxFooter || []}
              setTableData={handleSetTrxFooter}
              // ledgers={ledgers}
            /> */}
          </Grid>
        </Grid>
      )}
    </React.Fragment>
  );
}

export default AWBTrxPage;
